import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from '../util/types';

export type LANGUAGE_CODE =
    | 'ar'
    | 'bp'
    | 'cs'
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'ga'
    | 'gd'
    | 'it'
    | 'ja'
    | 'ko'
    | 'nl'
    | 'pl'
    | 'pt'
    | 'ru'
    | 'zh';

export interface ITranslationStorage {
    translation: (
        language: LANGUAGE_CODE,
        key: string,
        parameters?: string[],
        fallback?: string,
    ) => string;
}

export function injectTranslationStorage(
    container: IContainer = injectOrBuildContainer(),
): ITranslationStorage {
    return container.get<ITranslationStorage>(TYPES.ITranslationStorage);
}

export function bindTranslationStorage(
    val: ITranslationStorage,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<ITranslationStorage>(TYPES.ITranslationStorage, val);
}

export function unbindTranslationStorage(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.ITranslationStorage);
}
